module.exports = {"repositories":[],"extra":{"installer-paths":{"underpin":["alexstandiford/underpin"]}},"require":{"underpin/image-with-text":"^1.0","underpin/title-with-text":"^1.0","underpin/social-media":"^1.0","underpin/contact-info":"^1.0","underpin/footer":"^1.0","underpin/header-nav":"^1.0","underpin/single-post":"^1.0","alexstandiford/underpin":"^1.0.2","underpin/icon-group":"^1.0","underpin/button-shortcode":"^1.0","underpin/store-hours":"^1.0","underpin/contact-flyout":"^1.0"},"name":"","description":"","type":""}


//////////////////
// WEBPACK FOOTER
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/composer.json
// module id = 284
// module chunks = 0